import { Capabilities } from '@sharefiledev/sfplugin-capability-contracts';
import { DefaultRequestListDataProvider } from '../PluginDataProvider/DefaultRequestListDataProvider';
import { getRequestListRID } from './getRequestListRID';

export const requestListCapabilities: Capabilities = {
	async getNavigationDetails(requestedByResourceId) {
		const requestListRID = getRequestListRID(requestedByResourceId);
		const navigationDetails = await DefaultRequestListDataProvider.getRequestList(
			requestListRID.entityId
		);
		return {
			name: navigationDetails.title,
			webAppPath: `/requestlists/${navigationDetails.requestListId}`,
		};
	},
};
